import { Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import useTranslation from '../lib/i18n/useTranslation';
export default function AuthLayout() {
  const [planBannerDisplay, setPlanBannerDisplay] = useState(false);
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect_url');
  const arg = searchParams.get('arg');
  const { t } = useTranslation();
  useEffect(() => {
    setPlanBannerDisplay(redirectUrl === "/profile" && arg === 'modal=upgrade-plan')
  }, [redirectUrl]);
  return (
    <Flex
      flexDirection="row"
      h="100%"
      w="100%"
      backgroundColor="background.white"
    >
      <Flex
        w={415}
        flexShrink={0}
        alignItems={'center'}
        justifyContent={'center'}
        flexDirection={'column'}
      >
        {planBannerDisplay && (
          <Flex
            px={3}
            py={3}
            borderBottom={"1px solid"}
            borderColor={"divider.coral"}
            backgroundColor={"background.coral"}
            fontWeight={"600"}
            w={"100%"}
            >
              <Text>{t('auth.needSignInBeforeUpgrade')}</Text>
          </Flex>
        )}
        <Flex
         alignItems={'center'}
         justifyContent={'center'}
         flexDirection={'column'}
         flex="1"
        >
          <Outlet />
        </Flex>
        <Flex p={3}>
          <Link to="/legal/terms-of-use" target="_blank" >
            <Text color="text.medium.coral" fontSize="12px">{t('auth.termsOfUse')}</Text>
          </Link>
          <Text to="/legal/privacy-policy" fontSize="12px" px={1}  color="text.medium.coral">•</Text>
          <Link to="/legal/privacy-policy" target="_blank" >
            <Text to="/legal/privacy-policy" fontSize="12px" target="_blank" color="text.medium.coral">{t('auth.privacyPolicy')}</Text>
          </Link>
          <Text to="/legal/privacy-policy" fontSize="12px" px={1}  color="text.medium.coral">•</Text>
          <Link to="https://bibliona.com" target="_blank" >
            <Text to="/legal/privacy-policy" fontSize="12px" target="_blank" color="text.medium.coral">{t('auth.info')}</Text>
          </Link>
        </Flex>
        <Flex
          px={3}
          py={3}
          borderTop={"1px solid"}
          borderColor={"divider.coral"}
          backgroundColor={"background.coral"}
          fontWeight={"600"}
          w={"100%"}
          display={["inherit", "none"]}
          >
            <Text>{t('auth.optimizedForLargerScreen')}</Text>
        </Flex>
      </Flex>
      <Flex
        display={["none", "flex"]}
        flex="1"
        minW={0}
        background={"background.grey"}
        h="100%"
        w="auto"
        justifyContent={'center'}
        alignItems={'center'}
        overflow={"hidden"}
        borderLeft="1px solid"
        borderColor="divider.grey"
      >
        <img
          src="/sign-in/sign-in-illustration.webp"
          alt="Sign in illustration"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Flex>
    </Flex>
  )
}
